// invoiceTemplate.ts
type OrderProduct = {
  productName: string;
  quantity: number;
  totalPrice: number | string;
};

type InvoiceOrder = {
  CustomerName: string;
  orderDate: string;
  products?: OrderProduct[];
  totalAmount: number | string;
};

const currency = (val: number | string) => `${Number(val || 0).toFixed(2)} QAR`;

export function buildInvoiceHtml(order: InvoiceOrder) {
  if (!order) return "";

  const rows = (order.products || [])
    .map(
      (p, idx) => `
        <tr>
          <td>${idx + 1}</td>
          <td>${p.productName}</td>
          <td>${p.quantity}</td>
          <td>${currency(p.totalPrice)}</td>
        </tr>
      `
    )
    .join("");

  return `
    <!DOCTYPE html>
    <html lang="en">
    <head>
      <meta charset="UTF-8" />
      <style>
        body { font-family: Arial, sans-serif; font-size: 12px; }
        .invoice-box { padding: 20px; border: 1px solid #ddd; }
        h1 { text-align: center; }
        table { width: 100%; border-collapse: collapse; margin-top: 20px; }
        th, td { border: 1px solid #ddd; padding: 10px; font-size: 12px; }
        th { background: #f1f1f1; }
        .total { text-align: right; font-weight: bold; }
      </style>
    </head>
    <body>
      <div class="invoice-box">
        <h1>Invoice</h1>
        <p><strong>Customer:</strong> ${order.CustomerName}</p>
        <p><strong>Date:</strong> ${order.orderDate}</p>
        <table>
          <thead>
            <tr>
              <th>S No</th>
              <th>Product</th>
              <th>Qty</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            ${rows}
          </tbody>
          <tfoot>
            <tr>
              <td colspan="3" class="total">Total</td>
              <td>${currency(order.totalAmount)}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </body>
    </html>
  `;
}

